import { render, staticRenderFns } from "./VouchersTicket.vue?vue&type=template&id=528eca1d&scoped=true&"
import script from "./VouchersTicket.vue?vue&type=script&lang=js&"
export * from "./VouchersTicket.vue?vue&type=script&lang=js&"
import style0 from "./VouchersTicket.vue?vue&type=style&index=0&id=528eca1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528eca1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
